/*
 * PortUNA Framework (http://www.portuna.de/)
 *
 * @author     Grandke, Luke <grandke@portuna.de>
 * @copyright  PortUNA Neue Medien GmbH (http://www.portuna.de)
 * @created    17.9.2024 9:53 Uhr
 */
import {ref, type Plugin} from 'vue';

export let viewPortSize = ref<ViewSize>({
    xs: false,
    xsDown: false,
    xsUp: false,
    sm: false,
    smDown: false,
    smUp: false,
    md: false,
    mdDown: false,
    mdUp: false,
    lg: false,
    lgDown: false,
    lgUp: false,
    xl: false,
    xlDown: false,
    xlUp: false,
    xxl: false,
    xxlDown: false,
    xxlUp: false,
});

const portuna: Plugin = {
    install: (app) => {
        app.provide('viewPortSize', viewPortSize);
    }
};

export default portuna;